import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-71364514"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "conditioner"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "content-text"
};
const _hoisted_5 = {
  class: "content-link"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "content"
};
const _hoisted_8 = {
  class: "orderliness"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "circle"
}, null, -1));
const _hoisted_10 = {
  class: "line"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "circle"
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "circle"
}, null, -1));
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = {
  class: "content"
};
const _hoisted_15 = {
  class: "content-text"
};
const _hoisted_16 = {
  class: "content-text"
};
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"content-text code\" data-v-71364514><div data-v-71364514>@inproceedings{Cui_2022_MM,</div><div data-v-71364514>title={Understanding and Identifying Artwork Plagiarism with the Wisdom of Designers: A Case Study on Poster Artworks}, </div><div data-v-71364514>author={Cui, Shenglan and Fang, Liu and Zhou, Tongqing and Zhang, Mohan},</div><div data-v-71364514>booktitle={In Proceedings of the ACM International Conference on Multimedia},</div><div data-v-71364514>address={Lisboa, Portugal},</div><div data-v-71364514>year={2022},</div><div data-v-71364514>publisher={ACMPress},</div><div data-v-71364514>doi={10.1145/3503161.3548433},</div><div class=\"spacing\" data-v-71364514>}</div><div data-v-71364514>Shenglan Cui, Fang Liu, Tongqing Zhou, and Mohan Zhang. 2022. Understanding and Identifying Artwork Plagiarism with the Wisdom of Designers: A Case Study on Poster Artworks. In Proceedings of the 30th ACM International Conference on Multimedia (MM’22), October 10–14, 2022, Lisboa, Portugal. ACM, New York, NY, USA, 11 pages. https://doi.org/10.1145/3503161.3548433. </div></div>", 1);
const _hoisted_18 = {
  class: "title"
};
const _hoisted_19 = {
  class: "content"
};
const _hoisted_20 = {
  class: "content-text explain"
};
const _hoisted_21 = {
  class: "serial-no"
};
const _hoisted_22 = {
  class: "serial"
};
const _hoisted_23 = {
  class: "serial-no"
};
const _hoisted_24 = {
  class: "serial"
};
const _hoisted_25 = {
  class: "serial-no"
};
const _hoisted_26 = {
  class: "serial"
};
const _hoisted_27 = {
  class: "serial-no"
};
const _hoisted_28 = {
  class: "serial"
};
const _hoisted_29 = {
  class: "serial-no"
};
const _hoisted_30 = {
  class: "serial"
};
const _hoisted_31 = {
  class: "button"
};
import { useRouter } from 'vue-router';
import i18n from '@/language/index';
export default {
  __name: 'PlagiarizedPoster',
  setup(__props) {
    const router = useRouter();
    const handleDown = () => {
      window.open('https://docs.google.com/forms/d/e/1FAIpQLSceyc7xbai0VZ9TXnvYB1rTDYWgQKClzlqXEU2FTPUv0Al63g/viewform?usp=sf_link', '_blank');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('resources.posterDataset')), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('resources.sketch')), 1), _createElementVNode("div", _hoisted_5, [_createTextVNode(_toDisplayString(_ctx.$t('resources.author')), 1), _createElementVNode("a", {
        href: "https://dl.acm.org/conference/mm",
        target: "_blank",
        class: _normalizeClass(_unref(i18n).global.locale.value === 'en' ? 'linkMargin' : '')
      }, _toDisplayString(_ctx.$t('resources.acm')), 3), _createTextVNode(" " + _toDisplayString(_ctx.$t('resources.time')), 1), _createElementVNode("a", {
        href: "https://scholar.google.jp/citations?user=PXo2aVUAAAAJ&hl=zh-CN&oi=sra",
        target: "_blank",
        class: _normalizeClass(_unref(i18n).global.locale.value === 'en' ? 'linkMargin' : '')
      }, _toDisplayString(_ctx.$t('resources.liu')), 3), _createTextVNode(_toDisplayString(_ctx.$t('resources.symbol')), 1), _createElementVNode("a", {
        href: "https://scholar.google.jp/citations?user=tKuwGIIAAAAJ&hl=zh-CN",
        target: "_blank",
        class: _normalizeClass(_unref(i18n).global.locale.value === 'en' ? 'linkMargin' : '')
      }, _toDisplayString(_ctx.$t('resources.zhou')), 3), _createTextVNode(_toDisplayString(_ctx.$t('resources.symbol')) + _toDisplayString(_ctx.$t('resources.zhang')), 1)])]), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('resources.what')), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("ul", _hoisted_8, [_createElementVNode("li", null, [_hoisted_9, _createTextVNode(" " + _toDisplayString(_ctx.$t('resources.type')), 1)]), _createElementVNode("li", _hoisted_10, _toDisplayString(_ctx.$t('resources.division')), 1), _createElementVNode("li", null, [_hoisted_11, _createTextVNode(" " + _toDisplayString(_ctx.$t('resources.contain')), 1)]), _createElementVNode("li", null, [_hoisted_12, _createTextVNode(" " + _toDisplayString(_ctx.$t('resources.paper')), 1)])])]), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('resources.download')), 1), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createTextVNode(_toDisplayString(_ctx.$t('resources.click')), 1), _createElementVNode("a", {
        href: "https://docs.google.com/forms/d/e/1FAIpQLSceyc7xbai0VZ9TXnvYB1rTDYWgQKClzlqXEU2FTPUv0Al63g/viewform?usp=sf_link",
        target: "_blank",
        class: _normalizeClass(_unref(i18n).global.locale.value === 'en' ? 'linkMargin' : '')
      }, _toDisplayString(_ctx.$t('resources.clickHere')), 3), _createTextVNode(_toDisplayString(_ctx.$t('resources.to')), 1)]), _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('resources.quote')), 1), _hoisted_17]), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('resources.statement')), 1), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createTextVNode(_toDisplayString(_ctx.$t('resources.source')) + " ", 1), _createElementVNode("span", {
        class: _normalizeClass(["content-link", _unref(i18n).global.locale.value === 'en' ? 'linkPadding' : ''])
      }, _toDisplayString(_ctx.$t('protection.research')), 3), _createTextVNode(" " + _toDisplayString(_ctx.$t('resources.read')), 1)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createTextVNode("1."), _createElementVNode("p", null, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('resources.definition')), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t('resources.longtext')), 1)])])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createTextVNode("2."), _createElementVNode("p", null, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('resources.creator')), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t('resources.findWorks')), 1)])])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createTextVNode("3."), _createElementVNode("p", null, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('resources.researcher')), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t('resources.emphasize')), 1)])])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createTextVNode("4."), _createElementVNode("p", null, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('resources.update')), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t('resources.promise')), 1)])])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createTextVNode("5."), _createElementVNode("p", null, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('resources.errors')), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t('resources.errorsExplain')), 1)])])])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", {
        class: "readBtn",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('/'))
      }, _toDisplayString(_ctx.$t('resources.readThesis')), 1), _createElementVNode("div", {
        class: "readBtn",
        onClick: handleDown
      }, _toDisplayString(_ctx.$t('resources.application')), 1)])]);
    };
  }
};